var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOutOfStock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.718 10.415v13.916l-13.334 1.63V12.046m0-.001l13.334-1.63M7.343 6.512l8.233-1.006m-6.192 6.539v13.917L2.243 21.07V7.155m0 0l7.141 4.89m13.334-1.649l3.604-6.174L18.445.609l-2.869 4.897m0 0l7.142 4.89m-7.289-4.89v5.782m-5.859.735L6.747 5.036.011 1.63l2.232 5.524",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#DBDBDB"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNyIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDI3IDI2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjREJEQkRCIj4KICAgICAgICA8cGF0aCBkPSJNMjIuNzE4IDEwLjQxNXYxMy45MTZsLTEzLjMzNCAxLjYzVjEyLjA0Nk05LjM4NCAxMi4wNDVsMTMuMzM0LTEuNjNNNy4zNDMgNi41MTJsOC4yMzMtMS4wMDZNOS4zODQgMTIuMDQ1djEzLjkxN0wyLjI0MyAyMS4wN1Y3LjE1NU0yLjI0MyA3LjE1NWw3LjE0MSA0Ljg5TTIyLjcxOCAxMC4zOTZsMy42MDQtNi4xNzRMMTguNDQ1LjYwOWwtMi44NjkgNC44OTdNMTUuNTc2IDUuNTA2bDcuMTQyIDQuODlNMTUuNDI5IDUuNTA2djUuNzgyTTkuNTcgMTIuMDIzTDYuNzQ3IDUuMDM2LjAxMSAxLjYzbDIuMjMyIDUuNTI0Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgOutOfStock as ReactComponent };